import React, { useState } from 'react'
import Grid from "@material-ui/core/Grid";
import { useStyle } from "./Style";
import useProductCurrency from '../../../../../../../hooks/useProductCurrency'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const PoliciesDependants = (props) => {
  const classes = useStyle();


  const [expanded, setExpanded] = useState(false)

  const currencyCode = useProductCurrency(props.quote && props.quote.product_code)
  const dependants = (props.quote && props.quote.policy_schedule_entries) ? props.quote.policy_schedule_entries : null
  if (props.quote && dependants) {

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} >
            <div className={classes.policieswrapper}>
              <h2>  <strong>Plan :</strong> {props.quote.product_name}</h2>
              <table>
                <tr>
                  <th> Name</th>
                  <th>Relationship</th>
                  <th>Dob</th>
                  <th>Benefits</th>
                  <th>Premium</th>
                </tr>

                {
                  dependants.map((entry, index) => (
                    (
                      <>
                        <tr key={index}>
                          <td>{entry.dependant.first_name + " " + entry.dependant.last_name}</td>
                          <td>{entry.dependant.relationship}</td>
                          <td>{entry.dependant.date_of_birth}</td>
                          <td>
                            {/* <ol>
                              {
                                entry.benefits.map(benefit => {
                                  return <li>
                                    {benefit.type} - {<strong> {currencyCode + " " + (benefit.cover_amount_in_cents / 100).toLocaleString()}</strong>}
                                  </li>
                                })
                              }
                            </ol> */}
                            <ol>
                              {
                                entry.benefits.map(benefit => {
                                  return <>
                                    <li> {benefit.type} --   {
                                      benefit.type === "PHYSICAL CHECKUP" ? (<strong>
                                        <strong>{benefit.benefit_period_cardinality} / {benefit.benefit_period_granuality} </strong>
                                      </strong>) : benefit.type === "TELE CONSULT" ? (<strong>{benefit.benefit_period_cardinality} / {benefit.benefit_period_granuality}</strong>) :
                                      
                                      benefit.type === "HOSPITAL ADMISSION" ? (<>

                                        <strong>{currencyCode +
                                          " " + (benefit.cover_amount_in_cents / benefit.cover_usage_count) / (100).toLocaleString()} / per night</strong>
                                      </>) :
                                      
                                      (<strong> {currencyCode + " " + (benefit.cover_amount_in_cents / 100).toLocaleString()}</strong>)
                                    } </li>
                                  </>
                                })
                              }
                            </ol>

                          </td>
                          <td>{currencyCode + " " + entry.premium_amount_in_cents / 100}</td>
                        </tr>
                      </>
                    )
                  ))
                }
              </table>
              <br />
              <p style={{ textAlign: 'right' }}> total premium : {currencyCode + " " + props.quote.total_premium_amount_in_cents / 100}</p>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                  <div className={classes.showmoreshowless} onClick={() => setExpanded(!expanded)}>
                    <ul>
                      <li> {expanded ? 'Show Less' : 'Show More'}</li>
                      <li>{
                        expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </>
    )
  } else {
    return "No Dependants Found"
  }


}

export default PoliciesDependants